import CallBackForm from './CallBackForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setTelemetryUser } from 'services/store/features/telemetry/actions';
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({ setTelemetryUser: setTelemetryUser }, dispatch),
}); };
export default connect(null, mapDispatchToProps)(CallBackForm);
